import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DocumentModel } from "@models/documents/documentmodel";
import { CerrixDropAreaComponent } from "../../cerrix-drop-area/cerrix-drop-area.component";
import { CerrixConfirmationButtonComponent } from "../../cerrix-confirmation-button/cerrix-confirmation-button.component";
import { CerrixEditDocumentHistoryItemComponent } from "../cerrix-edit-document-history-item/cerrix-edit-document-history-item.component";
import { CerrixAccordionGroupComponent } from "@app/shared/cerrix-accordion-group/cerrix-accordion-group.component";
import { DateTimeDisplayPipe } from "@app/shared/pipes/date-time-display.pipe";
import { AbstractEditDocumentComponent } from "../cerrix-edit-document-abstract-component";
import { DocumentManagerService } from "@app/controls/testing/advanced/detail-new/common/services/document-manager.service";
import { AbstractDocumentModel } from "../../models/abstract-document-model";
import { DocumentConfig } from "@models/documents/DocumentConfig";
import { of } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CerrixButtonComponent } from "@app/incident/components/src/lib/core/cerrix-button/cerrix-button.component";
import { CerrixTitleComponent } from "@app/incident/components/src/lib/core/cerrix-title/cerrix-title.component";
import { CerrixFieldWrapperComponent } from "@app/incident/components/src/lib/core/cerrix-field-wrapper/cerrix-field-wrapper.component";
import { CerrixSelectComponent } from "@app/incident/components/src/lib/core/cerrix-select/cerrix-select.component";
import { CerrixTextareaComponent } from "@app/incident/components/src/lib/core/cerrix-textarea/cerrix-textarea.component";
import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";

@Component({
    selector: "cerrix-edit-document-monolith",
    templateUrl: "../cerrix-edit-document-incidents/cerrix-edit-document-incidents.component.html",
    styleUrls: ["../cerrix-edit-document-incidents/cerrix-edit-document-incidents.component.scss"],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatTabsModule,
        CerrixAccordionGroupComponent,
        CerrixButtonComponent,
        CerrixTitleComponent,
        CerrixFieldWrapperComponent,
        CerrixSelectComponent,
        CerrixTextareaComponent,
        CerrixTextareaComponent,
        CerrixDropAreaComponent,
        CerrixConfirmationButtonComponent,
        CerrixEditDocumentHistoryItemComponent,
        DateTimeDisplayPipe,
    ]
})
export class CerrixEditDocumentMonolithComponent extends AbstractEditDocumentComponent implements OnInit {
    private documentsService = inject(DocumentManagerService);
    protected historyDocuments: DocumentModel[] = [];

    ngOnInit(): void {
        super.ngOnInit();
    }

    protected loadData() {
        let doc = this.dialogData.documents[0] as DocumentModel;
        if (doc.IsNew) {
            this.getDocumentConfig()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((documentConfig) => {
                    this.documentConfig = this.handleDocumentConfig(documentConfig);
                    this.historyDocuments = [];

                    this.historyLoaded = true;
                });
        } else {
            super.loadData();
        }
    }

    public getDocumentTypes() {
        return of([]);
    }

    handleDocumentTypes(documentTypes: SelectOptionModel[]): SelectOptionModel[] {
        return documentTypes;
    }

    public getDocumentConfig() {
        return this.documentsService.getDocumentConfig();
    }

    handleDocumentConfig(documentConfig: DocumentConfig): DocumentConfig {
        return documentConfig;
    }

    public getDocumentHistory(documentId: string) {
        return this.documentsService.getDocumentHistory(documentId);
    }

    handleDocumentHistory(history: AbstractDocumentModel[]): DocumentModel[] {
        let parsedHistoryDocuments: DocumentModel[] = [];
        history.reverse().forEach((doc) => {
            const parsedDoc = this.documentsService.convertPropertiesToAbstract(
                doc as DocumentModel
            );
            parsedDoc.documentTypeId =
                this.dialogData.documentTypes.find((type) => type.id === doc.documentTypeId)
                    ?.name || "-";
            parsedHistoryDocuments.push(parsedDoc);
        });

        return parsedHistoryDocuments;
    }

    public validateUploadLimit(files: File[]) {
        return this.documentsService.validateUploadLimit(
            files,
            this.documentConfig.maxUploadSizeInMb
        );
    }

    public filterAllowedFiles(files: FileList) {
        return this.documentsService.filterAllowedFiles(
            files,
            this.documentConfig.allowedFileExtensions
        );
    }

    public getDocumentIcon(name: string) {
        return this.documentsService.getDocumentIcon(name);
    }
}
